import { useState } from "react";
import { InputBase, IconButton } from "@mui/material";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import LoadingShort from "../../load/loadingShort";
// import TextField from '@material-ui/core/TextField';
// import {MenuItem } from '@mui/material';
// import MessageError from "../messages/messageError";
import api from "../../services/api";

const SearchDirectorTecnico = ({ setDirectorTecnico, setPesquisaError }) => {
    // const [messageError, setMessageError] = useState('');
    const [load, setLoad] = useState(false);
    const [search, setSearch] = useState(false);

    const searchDirectorTecnico = async (e) => {
        e.preventDefault()
        setLoad(true)
        setPesquisaError(null)
        setDirectorTecnico([])

        try {
            const response = await api.post(`/director-tecnico/search`, {search})
            setLoad(false)
            // console.log(response)
            setDirectorTecnico(response.data.directorTecnicos)

        } catch (error) {
            setLoad(false)
            // console.log(error)
            setPesquisaError(error.response.data.message);
        }
    }

    return (
        <form onSubmit={searchDirectorTecnico} style={{ border: '1px solid #85287e', borderRadius: 5, display: 'flex', marginBottom: 25 }}>
            <InputBase
                sx={{ ml: 1, flex: 1 }}
                autoFocus
                placeholder="Pequisa pelo B.I, carteira, telefone, email.."
                inputProps={{ 'aria-label': 'Filtrar lista' }}
                onChange={(e) => { setSearch(e.target.value) }}
            />

            <IconButton style={{ marginLeft: -40 }} align='center' type="submit" aria-label="search">
                {load ?
                    <LoadingShort />
                    :
                    <SearchOutlinedIcon />
                }
            </IconButton>
        </form>
    );
}

export default SearchDirectorTecnico;
